import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';

import { Modal } from 'bootstrap';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

import { RoutineService } from 'src/app/services/routine.service';
import { StateService } from 'src/app/services/state.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';

import { User } from 'src/app/interfaces/user';
import { RoutineGroup, RoutineModel } from 'src/app/interfaces/routine';

@Component({
  selector: 'app-routines',
  templateUrl: './routines.component.html',
  styleUrls: ['./routines.component.scss'],
})
export class RoutinesComponent implements OnInit {
  isMobile: boolean = false;
  user: User | undefined;
  selectedUser: User | undefined;
  routines: any[] = [];

  selectedGroup: RoutineGroup | undefined;
  selectedRoutineModel: RoutineModel | undefined;
  routineGroups: RoutineGroup[] = [];
  selectedRoutineGroup: RoutineGroup | undefined;
  accordionMode: 'calendar' | 'list' = 'list';

  editing: boolean = false;
  editingRoutineGroup: boolean = false;
  watching: boolean = false;

  constructor(
    private storageService: StorageService,
    private routineService: RoutineService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private deviceService: DeviceDetectorService,
    private stateService: StateService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    dayjs.extend(utc);
    this.selectedUser = this.storageService.get('selectedUser', true);
    this.user = this.storageService.get('staffUser', true);

    this.isMobile = this.deviceService.isMobile();

    this.getUserRoutines();
  }

  openCalendarModal() {
    if (this.stateService.openModal) {
      this.stateService.openModal.hide();
    }

    const workoutCalendarModal = new Modal('#workoutCalendarModal');
    this.stateService.openModal = workoutCalendarModal;

    workoutCalendarModal.show();
  }

  getUserRoutines() {
    const userId = this.route.snapshot.paramMap.get('userId')!;

    this.routineService.getRoutineGroups(userId).subscribe({
      next: (response: any) => {
        response.routineGroups.forEach((rg: RoutineGroup) => {
          const finishedAtParsed = dayjs(rg.finishAt.Time).utc();

          rg.finishAtParsed = `${finishedAtParsed
            .get('date')
            .toString()
            .padStart(2, '0')}/${(finishedAtParsed.get('month') + 1)
            .toString()
            .padStart(2, '0')}/${finishedAtParsed.get('year')}`;

          const startAtParsed = dayjs(rg.startAt as string).utc();
          rg.startAtParsed = `${startAtParsed
            .get('date')
            .toString()
            .padStart(2, '0')}/${(startAtParsed.get('month') + 1)
            .toString()
            .padStart(2, '0')}/${startAtParsed.get('year')}`;

          rg.experienceLabel = this.userService.userExperienceLevels.filter(
            (l: any) => l.level === rg.experience
          )[0].name;
        });

        this.routineGroups = response.routineGroups;

        this.selectedGroup = this.routineGroups![0];
      },
      error: (_error: any) => {
        this.toastService.alert(
          'No pudimos obtener tus rutinas. Si el error persiste contactate con el soporte.'
        );
      },
    });
  }

  getRoutineGroupProgretion(routineGroup: RoutineGroup) {
    routineGroup.sendingEmail = true;
    this.routineService
      .getProgretion(this.selectedUser!.id, routineGroup.id!)
      .subscribe({
        next: () => {
          routineGroup.sendingEmail = false;
          this.toastService.success(
            'Te llegó un email a tu correo con las progresiones! 📖💪🏼'
          );
        },
        error: () => {
          this.toastService.alert(
            'Ocurrio un error enviando el email a tu correo con las progresiones, contactate con el soporte. 😕'
          );
        },
      });
  }

  deleteRoutineModel(routineModel: RoutineModel, routineGroup: RoutineGroup) {
    if (confirm('¿Esta seguro que desea eliminar el día de la rutina?')) {
      this.routineService.deleteRoutineModel(routineModel.id!).subscribe({
        next: () => {
          this.toastService.success('Se elimino con éxito');
          routineGroup.routines = routineGroup.routines?.filter(
            (rm) => rm.id != routineModel.id
          );
        },
        error: () => {
          this.toastService.alert(
            'No se pudo eliminar el día de la rutina con éxito.'
          );
        },
      });
    }
  }

  finishRoutineGroup() {
    if (confirm('¿Estás seguro que quieres finalizar la rutina?')) {
      this.routineService.finishRoutineGroup(this.selectedUser!.id).subscribe({
        next: () => {
          this.toastService.success('Rutina finalizada con éxito.');
          this.getUserRoutines();
        },
        error: () => {
          this.toastService.alert('No se pudo finalizar la rutina.');
        },
      });
    }
  }

  get createRoutineGroupValidButton(): boolean {
    let returnValue: boolean = true;

    const routineGroupsAsigned = this.routineGroups.filter(
      (rg: RoutineGroup) => rg.isOwn == false && rg.status == 'IN_PROGRESS'
    );

    if (routineGroupsAsigned.length > 0) {
      returnValue = false;
    }

    return returnValue;
  }

  openImportUserSelectorModal(routineGroup: RoutineGroup) {
    const importUserSelectorModal = new Modal('#importUserSelectorModal');
    this.stateService.openModal = importUserSelectorModal;

    this.stateService.selectedRoutineGroup = routineGroup;

    importUserSelectorModal.show();
  }

  onRoutineModelCreated(routineModel: RoutineModel) {
    let routineGroup = this.routineGroups?.filter(
      (rg) => rg.id == routineModel.routineModelGroupId
    )[0];
    routineGroup?.routines?.push(routineModel);
  }

  routineModelStartedEditError() {
    this.toastService.alert(
      'No puedes editar el día de la rutina ya que el usuario ya empezo a registrar datos. Para modificarla debes crear una nueva.'
    );
  }

  showFinishRoutineGroupToast() {
    this.toastService.alert(
      'No puedes crear una nueva rutina porque tienes una en progreso.'
    );
  }

  routineGroupCreatedOrUpdated() {
    this.getUserRoutines();
    this.editingRoutineGroup = false;
    this.selectedGroup = undefined;
  }

  watchRoutineDetail(routineModel: RoutineModel) {
    this.watching = true;
    this.editing = true;
    this.selectedRoutineModel = routineModel;
  }

  editRoutineModel(routineModel: RoutineModel) {
    this.selectedRoutineModel = routineModel;
    this.editing = true;
  }

  selectGroup(group: RoutineGroup) {
    this.selectedGroup = group;
  }

  createRoutineModel() {
    this.editing = false;
  }
}
